import clsx from 'clsx'
import React, { useState } from 'react'

import { Button } from '@Components/Button'
import { useClub } from '@Domains/Club/Hook'
import { useTranslation } from '@Globals/Translations'
import { EmailValidationV2 } from '@Shared/Components/Forms/Validations/EmailValidation'
import { TextInput, useTextInputActionRef } from '@Shared/Components/Inputs/TextInput/TextInput'

import styles from './styles.module.scss'

export const ClubForgotPassword = () => {
  const { defaultEmail, forgotPassword, setModalState } = useClub()
  const { t } = useTranslation()
  const emailActionRef = useTextInputActionRef()
  const [email, setEmail] = useState(defaultEmail || '')
  const [isEmailSend, setIsEmailSend] = useState(false)
  const [genericError, setGenericError] = useState<string | undefined>()

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault()
        e.stopPropagation()
        emailActionRef.current?.touch()
        const isEmailValid = emailActionRef.current?.validate()
        if (isEmailValid) {
          const errorString = await forgotPassword(email)
          if (errorString) {
            setGenericError(errorString)
            return
          }

          setIsEmailSend(true)
        }
      }}
    >
      <p className={styles.bigLabel}>{t('common:TRENDHIMCLUB_ENTER_YOUR_EMAIL')}</p>
      <p>{t('common:TRENDHIMCLUB_LINK_TO_CREATE_NEW_PASSWORD')}</p>
      <TextInput
        actionRef={emailActionRef}
        autoFocus={!defaultEmail}
        className={styles.formElementGab}
        disabled={isEmailSend}
        id="ClubModal_Signup_Email"
        label={t('common:EMAIL_ADDRESS')}
        onChange={(value) => {
          setGenericError(undefined)
          setEmail(value)
        }}
        validations={[EmailValidationV2]}
        value={email}
      />
      {isEmailSend && (<p className={styles.green}>{t('common:TRENDHIMCLUB_EMAIL_SENT_RESET_PASSWORD')}</p>)}
      <Button
        autoFocus={!!defaultEmail}
        className={styles.nextButton}
        color="black"
        disabled={isEmailSend}
        style={{ margin: '0' }}
        type="submit"
      >
        {t('common:TRENDHIMCLUB_SEND_LABEL')}
      </Button>
      {genericError && <p className={styles.error}>{t(genericError)}</p>}
      {!isEmailSend && (
        <button className={clsx(styles.labelButton, styles.modeSwitch)} onClick={() => setModalState('SIGN_IN')} type="button">
          {t('common:LOGIN_LABEL')}
        </button>
      )}
    </form>
  )
}

